import { markReportsAsNotified } from '@dispatch/shared/services';
import { useMutate } from '../api/useMutate';
import { MarkReportsAsNotified } from '@dispatch/shared/types';

export const useMarkReportsAsNotified = () => {
  const { mutate, error, status } = useMutate(
    ['export-report'],
    (data: { reportsToMark: MarkReportsAsNotified[] }) =>
      markReportsAsNotified(data.reportsToMark),
    () => undefined
  );

  return {
    markReportsAsNotified: mutate,
    error,
    status,
  };
};
